exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".crm-prefill-tag {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 3px;\n  margin-left: 6px;\n  padding: 1px 7px;\n  border-radius: 100px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.5;\n  vertical-align: middle;\n  white-space: nowrap;\n  text-transform: none;\n}\n.crm-prefill-tag--verified {\n  background: #E3F6E8;\n  color: #1B7F35;\n}\n.crm-prefill-tag--unverified {\n  background: #FDEBDD;\n  color: #A94F0E;\n}\n.crm-prefill-tag--locked {\n  border: 1px solid currentColor;\n}\n.crm-prefill-tag .icon {\n  margin: 0 !important;\n  font-size: 11px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader!./~/less-loader!./src/styles/components/crmPrefillTag.less
// module id = 2868
// module chunks = 0